import { Radio } from "lucide-react";
import { Handle, Position, type Node, type NodeProps } from "@xyflow/react";
import type { LivestreamNodeData } from "./types";

export function LivestreamNode({ data: _data }: NodeProps<Node<LivestreamNodeData>>) {
  return (
    <div className="bg-white rounded-xl border-2 border-violet-300 shadow-md w-[280px] relative pb-10">
      <Handle
        type="target"
        position={Position.Left}
        className="!bg-violet-400 !w-3 !h-3 !border-2 !border-white"
        style={{ top: "22px", left: 0 }}
      />
      <div className="px-4 py-3 bg-violet-50 rounded-t-xl border-b border-violet-200">
        <div className="flex min-w-0 items-center gap-2">
          <Radio className="h-4 w-4 shrink-0 text-violet-500" />
          <span className="font-semibold text-sm text-violet-700">Livestream</span>
        </div>
        <p className="mt-1.5 text-xs text-violet-600">In-viewer experience</p>
      </div>
      <div className="absolute bottom-2 right-0 flex items-center">
        <Handle
          type="source"
          position={Position.Right}
          id="checkout-success"
          className="!bg-violet-400 !w-3 !h-3 !border-2 !border-white"
        />
      </div>
    </div>
  );
}
